//@ts-nocheck



interface BentoBoxItem {
  // Define item properties as needed
  [key: string]: any;
}

interface BentoBoxProps {
  sectionId: string;
  items?: BentoBoxItem[];
  boxLength?: string;
  mobileMode?: 'carousel' | string;
  [key: string]: any;
}

interface NormalizedBentoBox extends Omit<BentoBoxProps, 'items'> {
  bentosCardAlignment: string;
  itemsLength: number;
  isCarousel: boolean;
}

const getBentoBoxTemplate = (itemsLength: number, boxLength?: string): string => {
  switch (itemsLength) {
    case 1:
      return boxLength || ''
    case 2:
      return `double-${boxLength}` ?? 'double-equal'
    case 3:
      return `triple-${boxLength}` ?? 'triple-equal'
    default:
      if (itemsLength % 2 === 0) return `double-${boxLength}` ?? 'double-equal'
      if (itemsLength % 2 !== 0) return `triple-${boxLength}` ?? 'triple-equal'
      return boxLength || ''
  }
}

const BentoBox = ({ sectionId, ...rest }: BentoBoxProps): NormalizedBentoBox => {
  const { items, boxLength, mobileMode } = rest
  const itemsLength = items?.length ?? 0
  const bentosCardAlignment = getBentoBoxTemplate(itemsLength, boxLength)
  const isCarousel = mobileMode === 'carousel' ? true : false

  const normalizedData: NormalizedBentoBox = {
    ...rest,
    sectionId,
    bentosCardAlignment,
    itemsLength,
    isCarousel,
  }

  return normalizedData
}

export default BentoBox
